import { Phone, MessageSquare, ArrowDown } from "lucide-react";
import { useLang } from "@/LanguageContext";
import { PHONE_DISPLAY, PHONE_TEL } from "@/data/site";

export const Hero = () => {
  const { t } = useLang();
  return (
  <section
    id="top"
    data-testid="hero-section"
    className="relative grain min-h-[92vh] overflow-hidden border-b border-steel-700"
  >
    <img
      src="https://images.unsplash.com/photo-1698664683348-f9f35b809821?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
      alt="Welder laying a bead with sparks flying in a Central Valley shop"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-steel-950 via-steel-950/80 to-steel-950/40" />
    <div className="absolute inset-0 bg-black/40" />
    <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-steel-950 to-transparent" />

    <div className="relative z-10 mx-auto flex min-h-[92vh] max-w-[1400px] flex-col justify-end px-4 pb-16 pt-32 md:px-8 lg:px-12 lg:pb-24">
      <p
        data-testid="hero-eyebrow"
        className="mb-5 font-mono text-xs uppercase tracking-[0.25em] text-forge-soft animate-stamp-in"
      >
        {t.hero.eyebrow}
      </p>

      <h1
        data-testid="hero-headline"
        className="max-w-4xl font-head text-5xl font-black uppercase leading-[0.88] tracking-tighter text-steel-50 animate-stamp-in sm:text-6xl md:text-7xl lg:text-8xl"
        style={{ animationDelay: "80ms" }}
      >
        {t.hero.h1a}
        <br />
        <span className="text-forge-light">{t.hero.h1b}</span>
      </h1>

      <p
        className="mt-6 max-w-xl text-base leading-relaxed text-steel-400 animate-stamp-in sm:text-lg"
        style={{ animationDelay: "160ms" }}
      >
        {t.hero.sub}
      </p>

      <div className="mt-9 flex flex-wrap gap-3 animate-stamp-in" style={{ animationDelay: "240ms" }}>
        <a
          href={`tel:${PHONE_TEL}`}
          data-testid="hero-call-btn"
          className="group flex items-center gap-2.5 rounded-sm bg-forge px-7 py-4 font-head text-lg font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-forge-light"
        >
          <Phone size={19} strokeWidth={2.4} />
          {t.hero.call} · {PHONE_DISPLAY}
        </a>
        <a
          href={`sms:${PHONE_TEL}`}
          data-testid="hero-text-btn"
          className="flex items-center gap-2.5 rounded-sm border border-steel-400 bg-steel-950/40 px-7 py-4 font-head text-lg font-bold uppercase tracking-wide text-steel-50 backdrop-blur-sm transition-colors duration-200 hover:border-forge-light hover:text-forge-light"
        >
          <MessageSquare size={19} strokeWidth={2.4} />
          {t.hero.text}
        </a>
      </div>

      <div
        data-testid="trust-bar"
        className="mt-12 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-steel-700 pt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-steel-400 sm:text-xs"
      >
        {t.hero.trust.map((item, i) => (
          <span key={item} className="flex items-center gap-x-4">
            {i > 0 && <span className="text-forge">/</span>}
            {item}
          </span>
        ))}
      </div>

      <a
        href="#services"
        aria-label="Scroll to services"
        className="mt-10 hidden w-fit items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-steel-400 transition-colors duration-200 hover:text-forge-light lg:flex"
      >
        <ArrowDown size={14} className="animate-ember" /> {t.hero.scroll}
      </a>
    </div>
  </section>
  );
};
